import type { HTMLAttributes } from 'react';
import { useTranslation } from 'react-i18next';
import { classes } from './ui.tsx';

type TableScrollProps = Omit<HTMLAttributes<HTMLDivElement>, 'aria-label' | 'aria-labelledby'> &
  ({ 'aria-label': string; 'aria-labelledby'?: never } | { 'aria-labelledby': string; 'aria-label'?: never });

/** Each scroll landmark must identify its table, including on multi-table pages. */
export function TableScroll({ className, children, ...props }: TableScrollProps) {
  const { t } = useTranslation();
  return (
    <div
      role="region"
      aria-description={t('common.tableScrollHint')}
      tabIndex={0}
      {...props}
      className={classes('table-scroll overflow-x-auto', className)}
    >
      {children}
    </div>
  );
}
